import { IBadgeData } from "../../types/interfaces";
import {
  ICleanBadgeData,
  IGetBadgeData,
  IGetBadgeDataFailed,
  IGetBadgeDataSuccess,
  PublicBadgeActionsTypes,
} from "./publicBadgeTypes";

// GET DATA
export const getBadgeData = (badgeId: string): IGetBadgeData => {
  return {
    type: PublicBadgeActionsTypes.GET_BADGE_DATA,
    payload: {
      badgeId,
    },
  };
};

export const getBadgeDataSuccess = (
  badgeData: IBadgeData
): IGetBadgeDataSuccess => {
  return {
    type: PublicBadgeActionsTypes.GET_BADGE_DATA_SUCCESS,
    payload: {
      badgeData,
    },
  };
};

export const getBadgeDataFailed = (): IGetBadgeDataFailed => {
  return {
    type: PublicBadgeActionsTypes.GET_BADGE_DATA_FAILED,
  };
};

// CLEAN DATA
export const cleanBadgeData = (): ICleanBadgeData => {
  return {
    type: PublicBadgeActionsTypes.CLEAN_BADGE_DATA,
  };
};
